module.exports = __webpack_public_path__ + "ManasChhetri-b3327d96.webp";